(() => {
  if (window.__registerSuccessPopupScriptLoaded) {
    return;
  }

  window.__registerSuccessPopupScriptLoaded = true;

  function initRegisterSuccessSection(section) {
    if (!section || section.dataset.appPopupInitialized === 'true') {
      return;
    }

    const popup = section.querySelector('[data-app-popup]');
    const openButton = section.querySelector('[data-app-popup-open]');
    const closeButtons = section.querySelectorAll('[data-app-popup-close]');

    if (!popup || !openButton || typeof popup.showModal !== 'function') {
      return;
    }

    let previousBodyOverflow = '';
    let previousHtmlOverflow = '';
    let previousActiveElement = null;

    section.dataset.appPopupInitialized = 'true';

    function lockScroll() {
      previousBodyOverflow = document.body.style.overflow;
      previousHtmlOverflow = document.documentElement.style.overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    function unlockScroll() {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    }

    function openPopup() {
      if (popup.open) {
        return;
      }

      previousActiveElement = document.activeElement;
      lockScroll();
      popup.showModal();
      openButton.setAttribute('aria-expanded', 'true');
    }

    function closePopup() {
      if (!popup.open) {
        return;
      }

      popup.close();
      unlockScroll();
      openButton.setAttribute('aria-expanded', 'false');

      if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus();
      }
    }

    openButton.addEventListener('click', openPopup);

    closeButtons.forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    popup.addEventListener('click', (event) => {
      if (event.target === popup) {
        closePopup();
      }
    });

    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });
  }

  function initRegisterSuccessSections(root = document) {
    if (root.matches && root.matches('[data-register-success]')) {
      initRegisterSuccessSection(root);
    }

    root.querySelectorAll('[data-register-success]').forEach(initRegisterSuccessSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRegisterSuccessSections());
  } else {
    initRegisterSuccessSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initRegisterSuccessSections(event.target);
  });
})();
